export default __webpack_public_path__ + "static/media/home-photography-img-05.7dcf3359.jpg";